import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from '../../CompanyPage/PaymentReceiptsContent/PaymentReceiptView/Styles'
import logo from '../../../../images/etax-logo.png'
import eFinance from '../../../../images/e-finance.png'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import { formatPhoneNumber } from '../../../../utils/helpers'

const NonCoreRequestPDFContent = ({ requestDetails, locale }) => {
  const classes = useStyles()

  return (
    <div id={'pdfContent'} className={classes.pdfContent + ' small'}>
      <h3 align={'center'}><FormattedMessage id='nonCoreLink.print.Title'
                                             values={{ req_num: requestDetails.request_number }}/></h3>
      <div className='first-row'>
        <div className='dateWrapper'>
          <div className='itemWrapper'>
            <h4 className='itemLabel'>{<FormattedMessage id='nonCoreLink.requestNumber'/>}</h4>
            <span className='itemValue'>{requestDetails.request_number}</span>
          </div>
          <div className='itemWrapper'>
            <h4 className='itemLabel'>{<FormattedMessage id='PaymentHeader.printDate'/>}</h4>
            <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                format="Do MMMM YYYY h:mm a"/></span>
          </div>
        </div>
        <img src={logo} alt='e-finance logo' width={120}/>
      </div>
      <div className='data-row'>
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='incentivesForm.placeholder.companyTaxId'/>}</h4>
          <span className='itemValue'>{requestDetails?.tax_id || 'N/A'}</span>
        </div>
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='linkCompanyForm.placeholder.email'/>}</h4>
          <span className='itemValue'>{requestDetails?.email || 'N/A'}</span>
        </div>
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='linkCompanyForm.placeholder.mobile'/>}</h4>
          <span className='itemValue mobile'>{formatPhoneNumber(requestDetails.phone)}</span>
        </div>
        {!!requestDetails.expiration_date &&
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='nonCoreLink.expiry_date'/>}</h4>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{requestDetails.expiration_date}</Moment></span>
        </div>
        }
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='nonCoreLink.tax_office_number'/>}</h4>
          <span className='itemValue'>{requestDetails?.tax_office_number || 'N/A'}</span>
        </div>
        <div className='itemWrapper'>
          <h4 className='itemLabel'>{<FormattedMessage id='PaymentHeader.userName'/>}</h4>
          <span className='itemValue'>{requestDetails?.username || 'N/A'}</span>
        </div>
      </div>
      <div className='last-row'>
        <h5><FormattedMessage id='footer.copyrights.poweredBy'/></h5>
        <img src={eFinance} alt='e-finance logo' width={230}/>
      </div>
      <br/>
      <br/>
    </div>
  )
}

export default NonCoreRequestPDFContent
